/** "EN · עב": the interface-language switch, on every screen (#445). */

import { useLocale, useMessages, type UiLocale } from '../i18n/locale.js';
import { defineMessages } from '../i18n/messages.js';
import { withMorph } from './page-morph.js';

const messages = defineMessages({
  en: { label: 'Display' },
  he: { label: 'תצוגה' },
});

const OPTIONS: readonly { readonly locale: UiLocale; readonly text: string }[] = [
  { locale: 'en', text: 'EN' },
  { locale: 'he', text: 'עב' },
];

export function LanguageSwitch(): React.JSX.Element {
  const { locale, setLocale } = useLocale();
  const t = useMessages(messages);
  return (
    <div className="language-switch" role="toolbar" aria-label={t.label}>
      {/* #556: a segmented pill; the buttons sit side by side, so the old " · " text separator is gone. */}
      {OPTIONS.map((option) => (
        <button
          key={option.locale}
          type="button"
          lang={option.locale}
          aria-pressed={locale === option.locale}
          onClick={() => withMorph(() => setLocale(option.locale))}
        >
          {option.text}
        </button>
      ))}
    </div>
  );
}
